<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">企业账号管理</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>企业账号管理</span></div>
            <ul class="forminfo">
    
                <li><label>企业名称<b>*</b></label><input name="" type="text" v-model="companyname" class="dfinput" value=""  /><i><b v-if="status==0">未审核</b><b v-else-if="status==1">审核通过</b><b v-else-if="status==-1">审核未通过</b><b v-else-if="status==2">审核关闭</b></i></li>
                
                <li><label>企业邮箱<b>*</b></label><input name="" type="text" v-model="email" class="dfinput" value=""  /></li>
                
                <li><label>企业地址<b>*</b></label><input name="" type="text" v-model="companyaddress" class="dfinput" value=""  /></li>
                
                <li><label>联系人<b>*</b></label><input name="" type="text" v-model="contact" class="dfinput" value=""  /></li>
                
                <li><label>电话号码<b>*</b></label><input name="" type="text" v-model="phonenum" class="dfinput" value=""  /></li>
            
                <li><label>手机</label><input name="" type="text" class="dfinput" v-model="mobile" value=""  /></li>
                
                <li><label>子账号个数</label><input name="" disabled="true" type="text" v-model="subaccountnum" class="dfinput" value=""  /></li>
                
                <li><label>电话盒子个数</label><input name="" disabled="true" type="text" v-model="subnum" class="dfinput" value=""  /></li>
                
                <li>
                    <label>身份证复印件<b>*</b></label>

                    <div class="buttonupload  click" v-if="personID.length > 1"> 已经上传 </div>
                    <input v-if="personID.length > 1" class="sure" type="button" @click="delfile('personID')"  value="删除文件">
                    <div  v-if="personID.length < 1"> 
                        <el-upload
                            class="upload-demo"
                            :on-success="uploadSuccess"
                            :action=personIDUploadUrl
                            :accept="'image/*'" 
                            :show-file-list="false"
                            :headers="uploadHeaders"
                            :on-change="handleChange">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </li>
                <li>
                    <label>营业执照复印件</label>
                    <div class="buttonupload  click" v-if="companycode.length > 1"> 已经上传 </div>
                    <input v-if="companycode.length > 1" class="sure" type="button" @click="delfile('companycode')" value="删除文件">
                    <div  v-if="companycode.length < 1"> 
                        <el-upload
                            class="upload-demo"
                            :on-success="uploadSuccess"
                            :action=companycodeUploadUrl
                            :accept="'image/*'" 
                            :show-file-list="false"
                            :headers="uploadHeaders"
                            :on-change="handleChange">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </li>
                
                <li><label>申请说明:</label><textarea name="" cols="" v-model="msg" rows="" class="textinput"></textarea></li>
            
                <li><label>&nbsp;</label><input class="sure" type="button" @click="updateenterprise()" value="确定">&nbsp;
                    <input class="cancel" type="button" value="取消">
                </li>
            </ul>
        </div>


    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            companyname:'',
            companyaddress:'',
            contact:'',
            phonenum:'',
            mobile:'',
            email:'',
            subaccountnum:'0',
            subnum:'0',
            status:0,
            companycode:'',
            personID:'',
            uploadHeaders:{},
            personIDUploadUrl:this.GLOBAL.serverSrc + '/enterprise/uploadpersonid.json',
            companycodeUploadUrl : this.GLOBAL.serverSrc + '/enterprise/uploadcompanycode.json',
            msg:'',
        }
    },
    mounted(){
        this.uploadHeaders.token = this.GLOBAL.token;
        this.getEnterpriseInfo();
    },
    methods:{
        handleChange(file, fileList) {
            
        },
        uploadSuccess(response){
            
            if (response.code === '0000000') {
                if(response.type == 'personid'){
                    this.personID = response.filePath;
                }
                else if(response.type == 'companycode'){
                    this.companycode = response.filePath;
                }
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                alert(response.msg);
            }
        },
        getEnterpriseInfo(){
            let that = this
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/enterprise/enterpriseinfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    //console.log(res.data.enterprise);
                    that.companyname = res.data.enterprise.companyname
                    that.companyaddress = res.data.enterprise.companyaddress
                    that.contact = res.data.enterprise.contact
                    that.phonenum = res.data.enterprise.phonenum
                    that.mobile = res.data.enterprise.mobile
                    that.email = res.data.enterprise.email
                    that.subaccountnum = res.data.enterprise.subaccountnum
                    that.subnum = res.data.enterprise.subnum
                    that.status = res.data.enterprise.status
                    that.personID = res.data.enterprise.personID == undefined ? '' : res.data.enterprise.personID;
                    that.companycode = res.data.enterprise.companycode == undefined ? '' : res.data.enterprise.companycode;
                    that.msg = res.data.enterprise.msg 
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        delfile(filetype){
            if(!confirm("确定需要删除文件吗？"))
            {
                return;
            }
            let that = this
            let data = {'fileType':filetype}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/enterprise/delenterprisefile.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.getEnterpriseInfo();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        updateenterprise(){
            if(this.companyname.trim().length < 1)
            {
                alert("企业名称不能为空！");
                return;
            }
            if(this.email.trim().length < 1)
            {
                alert("企业邮箱不能为空！");
                return;
            }
            if(this.companyaddress.trim().length < 1)
            {
                alert("企业地址不能为空！");
                return;
            }
            if(this.contact.trim().length < 1)
            {
                alert("联系人不能为空！");
                return;
            }
            if(this.phonenum.trim().length < 1)
            {
                alert("电话号码不能为空！");
                return;
            }
            if(this.personID.trim().length < 1)
            {
                alert("请上传身份证复印件！");
                return;
            }
            if(!confirm("确定需要修改吗？修改后需要重新审核！"))
            {
                return;
            }
            let data = {'companyname':this.companyname,'companyaddress':this.companyaddress,'contact':this.contact,'phonenum':this.phonenum,'mobile':this.mobile,'email':this.email,'msg':this.msg}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/enterprise/updenterprise.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("修改成功！")
                    that.getEnterpriseInfo();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/enterprise/enterprise.vue